import React from 'react'
import { useSelector } from 'react-redux'
import DisconnectedData from './DisconnectedData.container'
import LoadingContent from '../../components/Placeholders/LoadingContent'
import Table from '../../components/Tables/Table'
import TableCell from '../../components/Tables/TableCell'
import TableRow from '../../components/Tables/TableRow'
import { Paper, Box } from '@material-ui/core'
import { usePagination } from '../../components/Tables/Pagination.hooks'
import Typography from '../../components/Basics/Typography'
import Pagination from '../../components/Tables/Pagination'

/**
 * The FuelingForecastTable's container.
 * Shows the fueling prediction per truck (hours until fueling, estimated fueling
 * time, estimated critical time and the backend's "enviar a carga" flag).
 */
const FuelingForecastTable = () => {
  const { error, loading, trucks } = useSelector(state => state.fuelLevel)

  // most urgent first; trucks without prediction go last
  const sortedTrucks = [...trucks].sort((a, b) => {
    if (a.horas_hasta_carga === null) return 1
    if (b.horas_hasta_carga === null) return -1
    return a.horas_hasta_carga - b.horas_hasta_carga
  })

  const { page, totalPages, onChangePage, onGetCurrentPage } = usePagination({
    data: sortedTrucks,
    initialPage: 1,
    rowsPerPage: 19
  })

  return (
    <>
      {loading && <LoadingContent />}
      {!loading && error && <DisconnectedData />}
      {!loading && !error && (
        <Box style={{ marginLeft: '10px', minWidth: '5vw', width: '100%' }}>
          <Typography variant="h2" margin="0 0 20px 0">
            Estimación de próximos abastecimientos por equipo. Se actualiza junto con las predicciones (cada 5 a 10
            minutos).
          </Typography>
          <Paper style={{ overflow: 'auto' }}>
            {sortedTrucks.length === 0 ? (
              <Typography variant="h2" margin="0 0 20px 0">
                Sin data
              </Typography>
            ) : (
              <>
                <Table accesibility={{ label: 'FuelingForecast' }}>
                  <TableRow head>
                    <TableCell>Equipo</TableCell>
                    <TableCell>Combustible remanente</TableCell>
                    <TableCell>Horas hasta abastecimiento</TableCell>
                    <TableCell>Hora estimada de abastecimiento</TableCell>
                    <TableCell>Hora estimada de nivel crítico</TableCell>
                    <TableCell>Enviar a carga</TableCell>
                  </TableRow>

                  {onGetCurrentPage().map((row, index) => {
                    const rowColor = row.enviar_a_carga ? 'red' : ''
                    return (
                      <TableRow key={`forecast-${index}`}>
                        <TableCell align="center" minWidth="150px" color={rowColor}>
                          {row.patent}
                        </TableCell>
                        <TableCell align="center" minWidth="150px" color={rowColor}>
                          {Math.round(row.percent)} %
                        </TableCell>
                        <TableCell align="center" minWidth="150px" color={rowColor}>
                          {row.horas_hasta_carga !== null ? `${row.horas_hasta_carga.toFixed(1)} horas` : '—'}
                        </TableCell>
                        <TableCell align="center" minWidth="150px" color={rowColor}>
                          {row.hora_estimada_carga || '—'}
                        </TableCell>
                        <TableCell align="center" minWidth="150px" color={rowColor}>
                          {row.hora_estimada_critico || '—'}
                        </TableCell>
                        <TableCell align="center" minWidth="150px" color={rowColor}>
                          {row.enviar_a_carga ? 'Sí' : 'No'}
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </Table>
                <Pagination alignment="right" count={totalPages} page={page} onChange={onChangePage} />
              </>
            )}
          </Paper>
        </Box>
      )}
    </>
  )
}

export default FuelingForecastTable
